import { render, staticRenderFns } from "./addSupplies.vue?vue&type=template&id=71bac597&"
import script from "./addSupplies.vue?vue&type=script&lang=js&"
export * from "./addSupplies.vue?vue&type=script&lang=js&"
import style0 from "./addSupplies.vue?vue&type=style&index=0&id=71bac597&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports